import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

  private loadingCounter = 0;

  /** Activa el estado de carga */
  loadingOn(): void {
    this.loadingCounter++;
    this.setLoading(true);
  }

  /** Desactiva el estado de carga si no hay otras cargas activas */
  loadingOff(): void {
    if (this.loadingCounter > 0) {
      this.loadingCounter--;
    }
    if (this.loadingCounter === 0) {
      this.setLoading(false);
    }
  }

  /** Establece el estado del loading */
  private setLoading(isLoading: boolean): void {
    this.loadingSubject.next(isLoading);
  }
}
